import Swal from 'sweetalert2';
import axios from 'axios';

//檢查後端狀態碼
export function statusCheck(response)
{
    if (response.success == false) {
        Swal.fire({
            icon: "error",
            title: response.message ,
            showConfirmButton: false,
            timer: 1500
          });
        return false;
    }
    return true;
}

//套件功用
export function sweetalert(icon,title)
{
    Swal.fire({
        icon: icon,
        title: title ,
        showConfirmButton: false,
        timer: 1500
      });
}


export async function fetchDriverInfo(token) {
    const response = await axios.get(`${process.env.VUE_APP_PUBLIC_PATH}/api/driver/driver/info`, {
      headers: { Authorization: `Bearer ${token}` }
    });
    const userInfo = response.data.result;
    // 更新 localStorage
    localStorage.setItem('Driver', JSON.stringify({
      role: 'user',
      ...userInfo
    }));
  }